var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pa-4 pt-6" },
    [
      _c("WidgetUser"),
      _c(
        "v-flex",
        { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
        [
          _c(
            "FormFieldsContainer",
            { staticClass: "flex sm6 md6" },
            [
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "" } },
                [
                  _vm.categoriaUsuario === "Interno"
                    ? _c("v-autocomplete", {
                        attrs: {
                          label: _vm.formFields.empresa.label,
                          items: _vm.listaEmpresas,
                          "item-text": "nombre",
                          "item-value": "id"
                        },
                        on: { change: _vm.searchDataEmpresa },
                        model: {
                          value: _vm.formFields.empresa.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.empresa, "value", $$v)
                          },
                          expression: "formFields.empresa.value"
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "" } },
                [
                  _c("v-select", {
                    attrs: {
                      label: _vm.formFields.tipo.label,
                      items: _vm.listaTipos,
                      "item-text": "nombre",
                      "item-value": "id"
                    },
                    model: {
                      value: _vm.formFields.tipo.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.tipo, "value", $$v)
                      },
                      expression: "formFields.tipo.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "" } },
                [
                  _c("v-select", {
                    attrs: {
                      label: _vm.formFields.categoria.label,
                      items: _vm.listaCategorias,
                      "item-text": "nombre",
                      "item-value": "id"
                    },
                    model: {
                      value: _vm.formFields.categoria.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.categoria, "value", $$v)
                      },
                      expression: "formFields.categoria.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "" } },
                [
                  _c("v-combobox", {
                    attrs: {
                      items: _vm.formFields.patente.items,
                      label: _vm.formFields.patente.label,
                      multiple: "",
                      dense: ""
                    },
                    on: { change: _vm.patenteBlur },
                    model: {
                      value: _vm.activosSelected,
                      callback: function($$v) {
                        _vm.activosSelected = $$v
                      },
                      expression: "activosSelected"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "" } },
                [
                  _c("v-textarea", {
                    attrs: {
                      label: _vm.formFields.descripcion.label,
                      "no-resize": "",
                      rules: [
                        function(v) {
                          return (
                            v.length >= 10 || "Ingrese al menos 10 caracteres"
                          )
                        }
                      ],
                      value: "",
                      rows: "5"
                    },
                    model: {
                      value: _vm.formFields.descripcion.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.descripcion, "value", $$v)
                      },
                      expression: "formFields.descripcion.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "", sm12: "", md12: "", layout: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-sucursal",
                      staticStyle: { "margin-top": "10px" },
                      on: {
                        click: function($event) {
                          return _vm.$refs.image.click()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("attach_file")])],
                    1
                  ),
                  _c("v-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|extension|tamanio",
                        expression: "'required|extension|tamanio'"
                      }
                    ],
                    attrs: {
                      xs8: "",
                      sm8: "",
                      md8: "",
                      label: "Seleccione Archivo",
                      heigh: "",
                      "error-messages": _vm.errors.collect("archivo"),
                      "data-vv-name": "archivo",
                      readonly: "readonly"
                    },
                    on: {
                      click: function($event) {
                        return _vm.$refs.image.click()
                      }
                    },
                    model: {
                      value: _vm.fileName,
                      callback: function($$v) {
                        _vm.fileName = $$v
                      },
                      expression: "fileName"
                    }
                  }),
                  _c("input", {
                    key: _vm.idkey,
                    ref: "image",
                    staticStyle: { display: "none" },
                    attrs: { type: "file", accept: "*" },
                    on: { change: _vm.onFilePicked }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "" } },
                [
                  _c("p", [
                    _vm._v(
                      "Favor indicar datos del contacto a cargo de este requerimiento"
                    )
                  ]),
                  _c(
                    "v-radio-group",
                    {
                      model: {
                        value: _vm.radios,
                        callback: function($$v) {
                          _vm.radios = $$v
                        },
                        expression: "radios"
                      }
                    },
                    [
                      _c("v-radio", {
                        attrs: {
                          disabled: _vm.esInterno,
                          label: "Yo mismo",
                          value: "yo_mismo"
                        },
                        on: {
                          change: function($event) {
                            return _vm.checkTipoContacto(false)
                          }
                        }
                      }),
                      _c("v-radio", {
                        attrs: { label: "Otro", value: "otro" },
                        on: {
                          change: function($event) {
                            return _vm.checkTipoContacto(true)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-flex",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showTipoContacto,
                      expression: "showTipoContacto"
                    }
                  ],
                  attrs: { sm12: "", md12: "" }
                },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm8: "", md8: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.formFields.nombre.label,
                          "single-line": "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.formFields.nombre.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.nombre, "value", $$v)
                          },
                          expression: "formFields.nombre.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm8: "", md8: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.formFields.apellido.label,
                          "single-line": "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.formFields.apellido.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.apellido, "value", $$v)
                          },
                          expression: "formFields.apellido.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm8: "", md8: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.formFields.email.label,
                          "single-line": "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.formFields.email.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.email, "value", $$v)
                          },
                          expression: "formFields.email.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm8: "", md8: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.formFields.telefono.label,
                          "single-line": "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.formFields.telefono.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.telefono, "value", $$v)
                          },
                          expression: "formFields.telefono.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm8: "", md8: "" } },
                    [
                      _c("v-select", {
                        attrs: {
                          label: _vm.formFields.direccion.label,
                          items: _vm.listaDirecciones,
                          "item-text": "nombre",
                          "item-value": "id",
                          disabled: _vm.showNuevaDireccion
                        },
                        model: {
                          value: _vm.formFields.direccion.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.direccion, "value", $$v)
                          },
                          expression: "formFields.direccion.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c("v-flex", { attrs: { sm8: "", md8: "" } }, [
                    _c(
                      "div",
                      { staticClass: "text-sm-center" },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "btn-sucursal btn-nuevadir",
                            on: { click: _vm.nuevaDireccion }
                          },
                          [
                            _c("v-icon", [_vm._v("home")]),
                            _vm._v(" Nueva Dirección\n            ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _c(
                "v-flex",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showNuevaDireccion,
                      expression: "showNuevaDireccion"
                    }
                  ],
                  attrs: { sm12: "", md12: "" }
                },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm8: "", md8: "" } },
                    [
                      _c("v-select", {
                        attrs: {
                          label: _vm.formFields.region.label,
                          items: _vm.listaRegiones,
                          "item-text": "nombre",
                          "item-value": "id"
                        },
                        on: { change: _vm.searchComunas },
                        model: {
                          value: _vm.formFields.region.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.region, "value", $$v)
                          },
                          expression: "formFields.region.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm8: "", md8: "" } },
                    [
                      _c("v-select", {
                        attrs: {
                          label: _vm.formFields.comuna.label,
                          items: _vm.listaComunas,
                          "item-text": "nombre",
                          "item-value": "id"
                        },
                        model: {
                          value: _vm.formFields.comuna.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.comuna, "value", $$v)
                          },
                          expression: "formFields.comuna.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm8: "", md8: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.formFields.calle.label,
                          "single-line": "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.formFields.calle.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.calle, "value", $$v)
                          },
                          expression: "formFields.calle.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm8: "", md8: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.formFields.complemento.label,
                          "single-line": "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.formFields.complemento.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.complemento, "value", $$v)
                          },
                          expression: "formFields.complemento.value"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-flex",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  attrs: { sm12: "", md12: "" }
                },
                [
                  _c("p", [
                    _vm._v(
                      "¿Deseas recibir notificaciones de avance de tu solicitud?"
                    )
                  ]),
                  _c(
                    "v-radio-group",
                    {
                      model: {
                        value: _vm.radiosNotif,
                        callback: function($$v) {
                          _vm.radiosNotif = $$v
                        },
                        expression: "radiosNotif"
                      }
                    },
                    [
                      _c("v-radio", {
                        attrs: { label: "No.", value: "140390000" }
                      }),
                      _c("v-radio", {
                        attrs: {
                          label: "Sí, todas las notificaciones.",
                          value: "140390001"
                        }
                      }),
                      _c("v-radio", {
                        attrs: {
                          label: "Sí, solo para el cierre de solicitud.",
                          value: "140390002"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                _c(
                  "div",
                  { staticClass: "text-sm-center" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "btn-sucursal",
                        on: { click: _vm.enviar }
                      },
                      [
                        _c("v-icon", [_vm._v("send")]),
                        _vm._v(" Enviar\n          ")
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c(
            "v-flex",
            {
              staticStyle: { "text-align": "center" },
              attrs: { sm6: "", md6: "" }
            },
            [
              _c("img", {
                staticStyle: { "max-width": "500px" },
                attrs: {
                  width: "100%",
                  src:
                    "https://sucursalvirtual.gpschile.com/Img/ImagenSucursal.png"
                }
              })
            ]
          )
        ],
        1
      ),
      _vm.showRespuestaok
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c(
              "div",
              { staticClass: "modalEnvio", attrs: { id: "myModal2" } },
              [
                _c("div", { staticClass: "modalEnvio-content" }, [
                  _c("div", [
                    _vm._m(0),
                    _c(
                      "div",
                      {
                        staticClass: "buttonClose buttonCloseEvidencia",
                        attrs: { align: "right" }
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { flat: "", small: "", color: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.closeModal()
                              }
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              { staticClass: "importExportBtnIcon" },
                              [_vm._v("close")]
                            ),
                            _vm._v("  \n              "),
                            _c(
                              "span",
                              { staticClass: "importExportBtnTexto" },
                              [_vm._v("Cerrar")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("div", [
                      _c(
                        "ul",
                        [
                          _vm._l(_vm.numCasosPatentes, function(caso, key) {
                            return _c(
                              "li",
                              {
                                key: caso,
                                staticStyle: {
                                  "user-select": "auto !important"
                                }
                              },
                              [
                                _vm._v("\n                Patente "),
                                _c("strong", [_vm._v(_vm._s(key))]),
                                _vm._v(" Caso N°\n                "),
                                _c("strong", [_vm._v(_vm._s(caso))])
                              ]
                            )
                          }),
                          _vm._l(_vm.numCasosSinPatentes, function(caso) {
                            return _c(
                              "li",
                              {
                                key: caso,
                                staticStyle: {
                                  "user-select": "auto !important"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                Caso N° " +
                                    _vm._s(caso) +
                                    "\n              "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      ),
                      _c("p", [
                        _vm._v(
                          "\n              Nos pondremos en contacto dentro de las próximas 24 hrs de lunes\n              a viernes.\n            "
                        )
                      ])
                    ])
                  ])
                ])
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleEvidencia" }, [
      _c("h2", { staticClass: "importExportBtnIcon" }, [
        _vm._v("Resumen Caso(s) Creado(s)")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }